import { SavedSearch, SavedSearchAlertsFrequency } from '../types'
import { getApiClient } from './apiClient'

export const postSavedSearch = async (data: {
  name: string
  searchQuery: string
  alertsEnabled: boolean
  alertsFrequency: SavedSearchAlertsFrequency
  searchParams: Record<string, unknown>
}): Promise<SavedSearch> => {
  const response = await getApiClient().post('/', JSON.stringify(data))

  return response.data
}

export const updateSavedSearchByName = async (data: {
  name: string
  searchQuery: string
  alertsEnabled: boolean
  alertsFrequency: SavedSearchAlertsFrequency
}): Promise<void> => {
  const response = await getApiClient().put('/', JSON.stringify(data))

  return response.data
}

export const getSavedSearches = async (): Promise<SavedSearch[]> => {
  const response = await getApiClient().get('/')

  return response.data
}

export const deleteSavedSearches = async (ids: string[]): Promise<void> => {
  const response = await getApiClient().delete('/many', { data: { ids } })
  return response.data
}

export const runSavedSearch = async (id: number, searchParams: Record<string, unknown>): Promise<(number | string)[]> => {
  const response = await getApiClient().post(`/${id}/run`, JSON.stringify({ searchParams }))

  return response.data?.profiles
}

export const markViewedProfiles = async (data: { id: number; profileIds: (number | string)[] }): Promise<number[]> => {
  const response = await getApiClient().post(`/${data.id}/viewed`, JSON.stringify({ ids: data.profileIds }))

  return response.data
}

export const markAllProfilesViewed = async (data: { id: number; searchParams: unknown }): Promise<number[]> => {
  const { id, searchParams } = data

  const response = await getApiClient().post(`/${id}/viewed/all`, JSON.stringify({ searchParams }))

  return response.data
}
